var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_149_7626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.5C0 14.4706 4.02943 18.5 9 18.5C13.9706 18.5 18 14.4706 18 9.5C18 4.52943 13.9706 0.5 9 0.5C4.02943 0.5 0 4.52943 0 9.5Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5562 9.33592C6.97213 8.28337 8.58313 7.58941 9.38919 7.25416C11.6907 6.2969 12.1688 6.13062 12.4806 6.12505C12.5491 6.1239 12.7024 6.14092 12.8017 6.22147C12.8855 6.28947 12.9086 6.38138 12.9197 6.4459C12.9307 6.51037 12.9444 6.65735 12.9335 6.77215C12.8088 8.08255 12.2691 11.2626 11.9946 12.7303C11.8784 13.3513 11.6497 13.5596 11.4282 13.5799C10.947 13.6242 10.5815 13.2619 10.1154 12.9563C9.38599 12.4782 8.97395 12.1805 8.26594 11.714C7.44772 11.1748 7.97816 10.8785 8.44447 10.3941C8.56648 10.2674 10.6869 8.33872 10.7279 8.16372C10.7331 8.14184 10.7378 8.06028 10.6894 8.01719C10.6409 7.97416 10.5694 7.9889 10.5178 8.0006C10.4447 8.01719 9.27945 8.78737 7.02219 10.3111C6.69144 10.5382 6.39185 10.6488 6.12349 10.6431C5.82755 10.6366 5.25837 10.4757 4.83524 10.3382C4.31625 10.1695 3.90376 10.0803 3.93968 9.79379C3.95839 9.64456 4.16389 9.4919 4.5562 9.33592Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_149_7626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram1);
export default __webpack_public_path__ + "static/media/telegram 1.57193996aece4217cb21e1fbd37d6e94.svg";
export { ForwardRef as ReactComponent };